import {PACKAGES_URL} from "../../helpers/api.routes";
import {requests} from "../../helpers/api.services";

export const PackagesService = {
  getAll: (params: any) => requests.get(`${PACKAGES_URL}`, params),
  create: (params: FormData) => requests.post(`${PACKAGES_URL}`, params),
  getSingle: (id: number) => requests.get(`${PACKAGES_URL}/${id}`),
  update: (params: FormData, id: number) => requests.put(`${PACKAGES_URL}/${id}`, params),
  delete: (id: number) => requests.delete(`${PACKAGES_URL}/${id}`),
};